import { CamelCaseKeys, NumericString } from '@utils/typescript';
import { tEnum } from '@components/i18n';
import { InsuranceTypesEnum } from './InsuranceType';
import { InsurerLess } from './Insurer';
import { UserLess } from './User';
import { PolicyTypes } from './policyType';
import { Company } from './Company';
import { InsurerTeam } from './InsurerTeam';
import { PolicyBenefitTemplateLess } from './PolicyBenefitTemplate';

export enum InsurancePolicyStatuses {
  Pending = 'pending',
  Locked = 'locked',
  Active = 'active',
  Expired = 'expired',
  Ended = 'ended',
}

export type InsurancePolicyList = CamelCaseKeys<{
  id: number;
  insurance_type: InsuranceTypesEnum;
  policy_type: PolicyTypes;
  policy_number?: string;
  company_name?: string;
  member_name?: string;
  insured_name?: string;
  plan_type_names?: string;
  status: InsurancePolicyStatuses;
  total_premium: NumericString;
  total_premium_khr: NumericString;
  effective_date: string;
  expiration_date: string;

  insurer_id: number;
  insurer: InsurerLess;
  frontline?: UserLess;
}>;

export type InsurancePolicy = InsurancePolicyList &
  CamelCaseKeys<{
    admin_fee_amount: NumericString;
    admin_fee_final_amount: NumericString;
    premium: NumericString;
    final_premium: NumericString;
    invoiced_premium: NumericString;
    uninvoiced_premium: NumericString;
    brokerage_percentage: NumericString;
    description_html: string;

    can_lock: boolean;

    frontline: UserLess;
    company?: Company;
    user?: UserLess;
    insurer_team?: InsurerTeam;
    policy_benefit_templates: PolicyBenefitTemplateLess[];

    insurance_template_id: number;
    company_id: number;
    insurer_team_id: number;
    benefit_template_ids: number[];
  }>;

const INSURNACE_POLICY_STATUSES_VARIANTS_MAPPING = {
  [InsurancePolicyStatuses.Pending]: 'warning',
  [InsurancePolicyStatuses.Expired]: 'secondary',
  [InsurancePolicyStatuses.Active]: 'success',
  [InsurancePolicyStatuses.Ended]: 'secondary',
  [InsurancePolicyStatuses.Locked]: 'info',
};

export const getInsurancePolicyStatusVariant = (status: InsurancePolicyStatuses): string => INSURNACE_POLICY_STATUSES_VARIANTS_MAPPING[status];
export const tInsurancePolicyStatus = (status: InsurancePolicyStatuses) => tEnum('orderStatuses', status);
